const getCurrentTimeInSeconds = () => {
  return Math.floor(Date.now() / 1000);
};

export { getCurrentTimeInSeconds };
